import { ChangeEvent, HTMLAttributes } from 'react';
import { concat } from 'lodash';
import { useTranslations } from 'next-intl';
import { Dropdown } from './ProviderDropdown.styles';
import { DEFAULT_PROVIDER, PROVIDERS } from './constants';

type Props = {
  onChange: (provider: string) => void;
  value?: string;
} & Pick<HTMLAttributes<HTMLSelectElement>, 'className'>;

const ProviderDropdown = ({ onChange, value, className }: Props) => {
  const t = useTranslations('features.stageLegacy.stage.searchForm');
  const providerDropdownData = concat(
    {
      label: t('provider.select.all'),
      value: DEFAULT_PROVIDER,
    },
    PROVIDERS.map(provider => ({
      label: provider.label,
      value: provider.value,
    })),
  );
  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const provider = event.target.value;
    onChange?.(provider);
  };
  return (
    <Dropdown
      id="provider"
      label={t('provider.select.label')}
      value={value}
      options={providerDropdownData}
      onChange={handleChange}
      className={className}
    />
  );
};

export { ProviderDropdown as Dropdown };
